export default __webpack_public_path__ + "static/media/photo-downloaddisabled.5dc72a70.svg";